import React from "react";
import PropTypes from "prop-types";

// widget components
import SensorReadingsChartWidget from "../components/widgets/SensorGraph/SensorReadingsChartWidget.js";
import WidgetWrapperTextBoxLatestReading from "../components/widgets/textBox/WidgetWrapperTextBoxLatestReading.js";
import WidgetTextBox from "../components/widgets/textBox/WidgetTextBox.js";
import WidgetSlider from "../components/widgets/WidgetSlider.js";

const WidgetRenderer = ({
  widget, 
  deviceId, 
  device,
  outputs
}) => {
  switch (widget.widgetType) {

    case "latestReading":
      return (
        <WidgetWrapperTextBoxLatestReading
          deviceId={deviceId}
          readingKey={widget.readingKey}
          displayType={widget.displayType}
          description={widget.description}
        />
      );

    case "deviceProperty":
      return (
        <WidgetTextBox
          topRow={device?.[widget.readingKey] ?? "No data"}
          bottomRow={widget.label}
          description={widget.description}
        />
      );
    case "sensorChart":
      return (
        <SensorReadingsChartWidget
          title={widget.description}
          deviceId={deviceId}
          keys={widget.readingKey}
        />
      );
    case "slider":
    {
      const output = outputs?.[widget.id];

      if (!output) {
        return null;
      }
      return (
        <WidgetSlider
          deviceId={deviceId}
          displayTitle={widget.description}
          min={output?.min ?? 0}
          max={output?.max ?? 100}
          step={output?.step ?? 1}
          value ={output?.defaultValue ?? 0}
          type={output?.type ?? "temperature"}
          endpoint={output?.endpoint ?? 1}
        />
      );
    }
    default:
      return null;
  }
}

WidgetRenderer.propTypes = {
  widget: PropTypes.arrayOf(PropTypes.object).isRequired,
  device: PropTypes.arrayOf(PropTypes.object).isRequired,
  deviceId: PropTypes.string.isRequired,
  outputs: PropTypes.object,
};

export default WidgetRenderer;